import React, { Component } from 'react';
import scrollIntoView from 'scroll-into-view-if-needed';
import Message from './Message';
import './style.css';
import Suggestions from './Suggestions';


class MessageBoard extends Component {
	constructor(props) {
		super(props);

		this.state = { ...props }
		this.handleSubmitText = this.handleSubmitText.bind(this);
	}

	componentWillReceiveProps({ messages, listening, loading }) {
		this.setState({ messages, listening, loading }, () => {
			const scrollToBottom = messages.slice(-1) && messages.slice(-1)[0] ? messages.slice(-1)[0].scrollToBottom : (

				messages.slice(-1).length > 0
			)
			console.log("scrollToBottom", scrollToBottom, messages.slice(-1))
			if (scrollToBottom) {
				setTimeout(() => { this.scrollToBottom(); }, 200);
			}
		})
	}

	handleSubmitText(text, id, oneshot, resetContexts, element, queryType) {
		this.props.handleSubmitText(text, id, oneshot, resetContexts, element, queryType);
		console.log("1)");

		this.scrollToBottom();
	}

	render() {
		return (
			<div className={"card-body msg_card_body " + this.props.className} id="card_body" ref="container">
				<div></div>
				{(this.state.messages.map((element, index) => {
					if (element.suggestions) {
						return this.props.wizard !== false ? (
							<Suggestions
								backToTop={this.props.backToTop}
								{...element.oneshot ? { oneshot: true } : {}}
								{...typeof element.suggestions === 'object' ? {
									suggestions: element.suggestions,
									responseId: element.responseId,
									...{ ...(element.action ? { action: element.action } : {}) },
									...{ ...(element.parameters ? { parameters: element.parameters } : {}) },
								} : {}}
								onFirstLoadComplete={() => {
									// this.scrollToBottom();
									this.setState({ loadingSuggestions: false })
								}}
								key={"suggestions" + index}
								wizard={this.props.wizard}
								resetStatus={this.props.resetStatus}
								handleSubmit={this.handleSubmitText}
								handleOfflineResponse={this.props.handleOfflineResponse}
								locale={this.props.locale}
								scrollToBottom={this.scrollToBottom} />
						) : null;
					} else {
						return <Message index={index} element={element} key={index}></Message>;
					}
				}))}
				{this.state.messages.length === 0
					|| (!this.state.messages[this.state.messages.length - 1].suggestions
						&& this.state.messages[this.state.messages.length - 1].sender !== 'user'
						&& this.props.wizard !== false) ? ((this.state.messages.length === 1) ?
							<Suggestions
								backToTop={this.props.backToTop}
								onFirstLoadComplete={() => {
									// this.scrollToBottom();
									this.setState({ loadingSuggestions: false })
								}}
								key={"suggestions" + 0}
								resetStatus={this.props.resetStatus}
								handleSubmit={this.handleSubmitText}
								handleOfflineResponse={this.props.handleOfflineResponse}
								locale={this.props.locale}
								scrollToBottom={this.scrollToBottom} /> :
							<div
								className="suggestion_chip show_suggestions"
								style={{ marginTop: "32px" }}
								onClick={() => {
									this.props.onNewMessage({ suggestions: true });
									this.setState({ loadingSuggestions: true });
									setTimeout(() => { this.scrollToBottom(); }, 200);
								}}>
								<div>
									<div>
										{this.props.labelShowSuggestions}
									</div>
								</div>
							</div>) : null}
				<div style={{ float: "left", clear: "both" }} ref={(el) => { this.messagesEnd = el; }}>
					{this.state.listening === false ? null : <div className="" id="loading_message"><div className="info_container_send loading_message">{this.props.listeningLabel}</div></div>}
					{this.state.loading === false ? null : <div id="loading_message" className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>}
				</div>
			</div>
		);
	}

	scrollToBottom = () => {
		console.log("scrollToBottom")
		setTimeout(() => {
			scrollIntoView(this.messagesEnd, { scrollMode: 'if-needed', behavior: 'smooth' })
		}, this.isSafari ? 1000 : 200);
	}

	componentDidMount() {
		// this.scrollToBottom();
	}

	componentDidUpdate() {
		// this.scrollToBottom();
	}
}

export default MessageBoard;
